/*
 * @Author: v_smwang
 * @Date: 2020-07-24 18:48:27
 * @LastEditors: v_smwang
 * @LastEditTime: 2020-07-30 11:19:09
 * @FilePath: \src\main.js
 * @Description: 描述
 * @Module: 模块路径
 */
import Vue from 'vue';
import VueStorage from 'vue-ls';
// 引入AntdUI和css样式库
import AntdUI from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';
// 引入elementUI和css样式库
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './resetElment.css';
// 引入v-charts
import VCharts from 'v-charts';
import echarts from 'echarts';

import { VueServiceInstall } from '@/utils/request';
import PermissionHelper from '@/utils/helper/permission';
import bootstrap from '@/store/bootstrap';
import router from './router';
import store from './store';
import App from './App.vue';
import { WaterMark } from '@tencent/tks-utils/canvas';

Vue.directive('waterMark', {
  inserted(el, binding) {
    WaterMark(el, binding.value);
  },
});

Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;

Vue.use(VCharts);
Vue.use(ElementUI);
Vue.use(AntdUI);
Vue.use(VueStorage);
Vue.use(VueServiceInstall);
Vue.use(PermissionHelper);

new Vue({
  router,
  store,
  created() {
    bootstrap();
  },
  render: h => h(App),
}).$mount('#app');

if (typeof pgvMain === 'function') {
  // eslint-disable-next-line no-undef
  pgvMain({ repeatApplay: 'true' });
}
